var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.793 5.87493C14.593 5.8416 14.3847 5.83328 14.168 5.83328H5.83467C5.60133 5.83328 5.37633 5.84994 5.15967 5.88327C5.27633 5.64994 5.443 5.4333 5.643 5.2333L8.35133 2.51663C9.493 1.38329 11.343 1.38329 12.4847 2.51663L13.943 3.99159C14.4763 4.51659 14.7597 5.18327 14.793 5.87493Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50016 15.8333C7.50016 16.4583 7.32516 17.05 7.01683 17.55C6.44183 18.5167 5.3835 19.1667 4.16683 19.1667C2.95016 19.1667 1.89183 18.5167 1.31683 17.55C1.0085 17.05 0.833496 16.4583 0.833496 15.8333C0.833496 13.9917 2.32516 12.5 4.16683 12.5C6.0085 12.5 7.50016 13.9917 7.50016 15.8333Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.4096 15.8163H2.92627",
    stroke: "#2B2B2B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1665 14.5996V17.0913",
    stroke: "#2B2B2B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 10V14.1667C18.3332 16.6667 16.6665 18.3334 14.1665 18.3334H6.35817C6.6165 18.1167 6.8415 17.85 7.0165 17.55C7.32484 17.05 7.49984 16.4584 7.49984 15.8334C7.49984 13.9917 6.00817 12.5 4.1665 12.5C3.1665 12.5 2.27484 12.9417 1.6665 13.6334V10C1.6665 7.73337 3.03317 6.15004 5.15817 5.88337C5.37484 5.85004 5.59984 5.83337 5.83317 5.83337H14.1665C14.3832 5.83337 14.5915 5.8417 14.7915 5.87503C16.9415 6.12503 18.3332 7.71671 18.3332 10Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 10.4166H15.8332C14.9165 10.4166 14.1665 11.1666 14.1665 12.0833C14.1665 13 14.9165 13.75 15.8332 13.75H18.3332",
    stroke: "#2B2B2B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletAdd);
export default __webpack_public_path__ + "static/media/wallet-add.d49b39ff748f779a7dfdb8146f483ed7.svg";
export { ForwardRef as ReactComponent };